/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import '../node_modules/bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import SlickSlider from './components/slick';
import './selectors';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import Form from './components/form';
import usePasswordPolicy from './components/usePasswordPolicy';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';


import './components/block-cart';
import lazysizes from 'lazysizes'


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const form = new Form();
  let slickSlider = new SlickSlider();
  let topMenuEl = $('#_desktop_top_menu #top-menu');
  let topMenu = new TopMenu(topMenuEl);

  form.init();
  slickSlider.init();
  topMenu.init();
  usePasswordPolicy('.field-password-policy');

  //display input file content in custom file input BS
  $('.custom-file-input').on('change', function () {
    let fileName = $(this).val().split('\\').pop();
    $(this).next('.custom-file-label').addClass("selected").html(fileName);
  })

});
document.addEventListener('lazyloaded', function (e) {
  $(e.target).parent().addClass('rc--lazyload');
});


/* Brand carousel */
$(window).load(() => {
  $('#jsBrandCarousel').slick({
    arrows: true,
    dots: false,
    touchMove: true,
    swipe: true,
    draggable: true,
    cssEase: 'linear',
    slidesToShow: 10,
    slidesToScroll: 1,
    prevArrow: '<span class="slick-arrow-prev material-icons"></span>',
    nextArrow: '<span class="slick-arrow-next material-icons"></span>',
    responsive: [{
      breakpoint: 2000,
      settings: {
        slidesToShow: 10,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    ]
  }).removeClass('no-js');
});

/* Feedaty Product Page */
/* Add custom message if no reviews are found */
$(document).ready(() => {
  if ($("#product").length > 0) {
    setTimeout(function () {
      if ($(".feedaty_widget").length > 0) {
        if ($(".fdt_info").length == 0) {
          $(".feedaty_widget").append("Non ci sono recensioni per questo prodotto");
        }
      }
    }, 5000);
  }
});


/* Add to cart custom */
$("document").ready(function () {
  $(".js-add-to-cart-modal-trigger").on('click', function () {
    $("body").addClass('js-cart-modal-open');
  });
  $('.modal').on('shown.bs.modal', function () {
    $("body").removeClass('js-cart-modal-open');
  });
});

